import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';

export async function getCon(payload: {
  page?: number;
  limit?: number;
  cond?: number;
  childId?: string;
}) {
  const { page, limit, cond, childId } = payload;
  if (childId) {
    return axios.get(`${ip3}/con/${childId}`, {
      params: {
        page,
        limit,
        cond,
      },
    });
  }
  return axios.get(`${ip3}/con/pageable/my`, {
    params: {
      page,
      limit,
      cond,
    },
  });
}
export async function getConNew(payload: {
  page?: number;
  limit?: number;
  cond?: number;
  childId?: string;
}) {
  const { page, limit, cond, childId } = payload;
  return axios.get(`${ip3}/con/user/${childId}/pageable`, {
    params: {
      page,
      limit,
      cond,
    },
  });
}
export async function getKhaiBaoThongTin() {
  return axios.get(`${ip3}/khaibaothongtin/pageable`, { params: { page: 1, limit: 20 } });
}

export async function addConKhach(payload: any) {
  return axios.post(`${ip3}/con/my`, payload);
}
export async function addConKhachSA(payload: any) {
  return axios.post(`${ip3}/con`, payload);
}

export async function updConKhach(payload: any) {
  const { id } = payload;
  const vaiTro = localStorage.getItem('vaiTro');
  if (vaiTro === 'PhuHuynh'||vaiTro === 'Guest') {
    return axios.put(`${ip3}/con/my/${id}`, payload);
  }
  return axios.put(`${ip3}/con/${id}`, payload);
}

export async function importThongTinHocSinh(payload: any) {
  const file = payload?.file?.fileList?.[0].originFileObj;
  const form = new FormData();
  form.append('file', file);
  // const vaiTro = localStorage.getItem('vaiTro');
  // form.append('datatype', vaiTro === 'SuperAdmin' || vaiTro === 'Admin' ? 'Hệ thống' : 'Khác');
  return axios.post(`${ip3}/con/import/excel`, form, {
    params: {
      cond: {
        donViId: payload.donViId
      }
    },
  });
}

export async function updKhach(payload: any) {
  return axios.put(`${ip3}/user/my`, payload);
}

export async function delConKhach(payload: any) {
  const { id } = payload;
  return axios.delete(`${ip3}/con/my/${id}`, payload);
}
export async function delConKhachSA(payload: any) {
  const { id } = payload;
  return axios.delete(`${ip3}/con/${id}`, payload);
}
